/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Tryagain2Inputs */

const he_ratelimit_tryagain2 = /** @type {(inputs: Ratelimit_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נסה שוב`)
};

const en_ratelimit_tryagain2 = /** @type {(inputs: Ratelimit_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Ratelimit_Tryagain2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_tryagain2 = /** @type {((inputs?: Ratelimit_Tryagain2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Tryagain2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_tryagain2(inputs)
	return en_ratelimit_tryagain2(inputs)
});
export { ratelimit_tryagain2 as "rateLimit_tryAgain" }